import * as React from 'react';

import FileDescription16 from './FileDescription16';

export const fileDescription16 = () => <FileDescription16 />;

export default {
    title: 'Icon/Line/FileDescription16',
    component: FileDescription16,
    parameters: {
        notes: "`import FileDescription16 from 'box-ui-elements/es/icon/line/FileDescription16';`",
    },
};
